<template>
  <form class="add-participants-form" @submit.stop.prevent="handleSubmit">
    <search-input
      @search="(text) => searchText = text"
      class="search-input"/>
      <section
        class="wrapper-list"
      >
        <h4
          v-if="searchUnselectedContacts.length !== 0"
          class="list__title"
        >
          {{ $t('CP.participants') }}
        </h4>
        <add-participants-list
          v-if="searchUnselectedContacts.length !== 0 || showUsersNotFound || showAllAdded"
          @selectUser="selectUser"
          :enable-select="true"
          :selected="selectedUsers"
          :users="searchUnselectedContacts || []"
          :allow-focus="true"
          :show-delete-button="false"
          :show-phone="true"
          :showEmptyPlaceholder="showUsersNotFound"
          :showEmptyEventPlaceholder="showAllAdded"
          :is-user-owner="user.user === event.owner_id"
        />
        <h4
          v-if="searchOtherUnselectedContacts.length !== 0"
          class="list__title"
        >
          {{ $t('CP.currencyGroupOthers') }}
        </h4>
        <add-participants-list
          v-if="searchOtherUnselectedContacts.length !== 0"
          @selectUser="selectUser"
          :enable-select="true"
          :selected="selectedUsers"
          :users="searchOtherUnselectedContacts || []"
          :allow-focus="true"
          :show-delete-button="false"
          :show-phone="true"
          :showEmptyPlaceholder="false"
          :showEmptyEventPlaceholder="eventSelectedContacts.length == contacts.length"
          :is-user-owner="user.user === event.owner_id"
          style="max-height: none;"
        />
      </section>
    <div class="form-buttons">
      <button-app
        @clicked="cancelSubmit"
        type="button"
        class="form-button form-button_left"
        color-scheme="gray"
      >
        {{ $t('CP.cancel') }}
      </button-app>
      <button-app
        type="submit"
        class="form-button"
        color-scheme="blue"
        :disabled="!(selectedUsers.length)"
      >
        {{ $t('CP.add') }}
      </button-app>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  ADD_EVENT_SELECTED_CONTACTS_REQUEST, CLEAR_SEARCH_CONTACT,
} from '@/store/user/types';
import AddParticipantsList from '../../components/AddParticipantsList/AddParticipantsList';
import ButtonApp from '../../components/Button/ButtonApp';
import SearchInput from '../../components/SearchInput/SearchInput';
import functionsWithUser from '../../utils/mixins/functionsWithUser';

export default {
  name: 'AddParticipantsForm',
  components: {
    SearchInput,
    ButtonApp,
    AddParticipantsList,
  },
  extends: functionsWithUser,
  props: {
    parentModal: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedUsers: [],
      searchText: '',
    };
  },
  computed: {
    ...mapGetters(['eventUnselectedContacts']),
    ...mapState({
      contacts: (state) => state.user.eventContacts,
      user: (state) => state.user.user,
      userContacts: (state) => state.user.userContacts,
      event: (state) => state.events.event,
      searchContact: (state) => state.user.searchContact,
      eventSelectedContacts: (state) => state.user.eventSelectedContacts,
    }),
    isEventQuasi() {
      return this.event && !this.event.event_name;
    },
    otherContacts() {
      let array = [...this.userContacts];
      this.contacts.forEach((contact) => {
        array = array.filter((con) => con.uid !== contact.uid);
      });
      return [...array];
    },
    isSearchContactInParticipants() {
      return !!this.eventSelectedContacts
        .find((selectedContact) => (
          selectedContact.uid === this.searchContact.uid
          || selectedContact.user === this.searchContact.uid
        ));
    },
    searchUnselectedContacts() {
      const contacts = [];

      this.eventUnselectedContacts.forEach((contact) => {
        const contactCopy = { ...contact };
        const userName = this.$getUserName(contactCopy);
        let { phone } = contactCopy;

        phone = phone.replace(/\D/g, '').toLowerCase().trim();
        const searchName = this.searchText.toLowerCase().trim().replace(/\s$/, '');
        const searchNameList = [
          searchName, // original
          this.$cyrillicToTranslit.reverse(searchName), // to cyrillic
          this.$cyrillicToTranslit.transform(searchName), // to latin
        ];
        const isSearchNameMatch = searchNameList.some((item) => (
          userName.toLowerCase().indexOf(item) !== -1
        ));
        const searchPhone = this.searchText.replace(/[+()-\s]/g, '');
        if (userName && isSearchNameMatch) {
          if (userName !== this.user.full_name) {
            contacts.push(contactCopy);
          }
        } else if (/^\d+$/.test(searchPhone) && searchPhone && phone.indexOf(searchPhone) !== -1) {
          if (userName !== this.user.full_name) {
            if (!contacts.find((cntct) => cntct.uid === contactCopy.uid)) {
              contacts.push(contactCopy);
            }
          }
        }
      });
      return contacts;
    },
    searchOtherContacts() {
      const contacts = [];

      this.otherContacts.forEach((contact) => {
        const contactCopy = { ...contact };
        const userName = this.$getUserName(contactCopy);
        let { phone } = contactCopy;

        phone = phone.replace(/\D/g, '').toLowerCase().trim();
        const searchName = this.searchText.toLowerCase().trim();
        const searchNameList = [
          searchName, // original
          this.$cyrillicToTranslit.reverse(searchName), // to cyrillic
          this.$cyrillicToTranslit.transform(searchName), // to latin
        ];
        const isSearchNameMatch = searchNameList.some((item) => (
          userName.toLowerCase().indexOf(item) !== -1
        ));
        const searchPhone = this.searchText.replace(/\D/g, '').toLowerCase().trim();
        if (userName && isSearchNameMatch) {
          if (userName !== this.user.full_name) {
            contacts.push(contactCopy);
          }
        } else if (searchPhone && phone.indexOf(searchPhone) !== -1) {
          if (userName !== this.user.full_name) {
            if (!contacts.find((cntct) => cntct.uid === contactCopy.uid)) {
              contacts.push(contactCopy);
            }
          }
        }
      });
      return contacts;
    },
    searchOtherUnselectedContacts() {
      let contacts = [...this.searchOtherContacts];
      this.eventSelectedContacts.forEach((user) => {
        contacts = contacts.filter((contact) => contact.uid !== user.uid);
      });
      return contacts;
    },
    showUsersNotFound() {
      return this.searchOtherContacts.length === 0 && this.searchUnselectedContacts.length === 0;
    },
    showAllAdded() {
      return this.eventSelectedContacts.length === this.userContacts.length + 1;
    },
  },
  methods: {
    async handleSubmit() {
      await this.$store.dispatch(ADD_EVENT_SELECTED_CONTACTS_REQUEST,
        JSON.parse(JSON.stringify(this.selectedUsers)));
      this.$emit('submit', this.selectedUsers);
      this.selectedUsers = [];
      this.$bvModal.hide(this.parentModal);
    },
    cancelSubmit() {
      this.selectedUsers = [];
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$emit('cancel');
      this.$bvModal.hide(this.parentModal);
    },
    async addContact(contact) {
      await this.$store.dispatch(ADD_EVENT_SELECTED_CONTACTS_REQUEST, [contact]);
      this.$store.commit(CLEAR_SEARCH_CONTACT);
      this.$bvModal.hide('add-participants');
      this.$emit('submit');
    },
  },
};
</script>

<style lang='scss' scoped>
.title {
  color: var(--text-main-color);
}
.add-participants-form {
  font-size: 1rem;
  padding: 0 calc(32px - 1rem);
  max-height: 75vh;
}
.list__title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  flex: 1 0 100%;
  color: var(--text-main-color);
}

.wrapper-list {
  max-height: 69vh;
  overflow-y: auto;
}
.search-input {
  font-size: 1rem;
  margin: 0 0 15px;
}

.form-buttons {
  display: flex;
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 10svh;
}

.form-button {
  font-size: 13px;
  font-weight: bold;
  height: 38px;
  flex: 1 0 40%;
  margin: 0;
}

.form-button_left {
  margin: 0 8px 0 0;
}

@media (min-width: $breakpoint-sm) {
  .form-buttons {
    display: flex;
    width: 90%;
    position: relative;
    margin: 0 auto;
    left: auto;
    bottom: auto;
  }

  .wrapper-list {
    max-height: 50vh;
    margin-bottom: 8px;
  }
}
</style>
